import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout'
import Card from '../../../components/Card'
import DataGrid from 'react-data-grid'
import { ArrowUp, EmployeeImage, Reqimage } from '../../../assets/images'
import './index.css'
import CustomPagination from '../../../components/Pagination'
import { useNavigate } from 'react-router-dom'
import { PersonalTimeOff, Stats } from '../types'
import { dashboardstats, personalTimeOff, assignedTimeOff } from '../api'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
import { HIDE_LOADER, SHOW_LOADER } from '../../../redux/slices/LoaderSlice'
import { formatDate } from '../utils'

const Dashboard: React.FC = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { id } = useAppSelector((state) => state.persistedReducers.user)
    const { show } = useAppSelector((state) => state.loader)
    const [stats, setuserStats] = useState<Stats>({
        userCount: 0,
        timeOffCount: 0,
    })
    const [perosnaltimeOff, setPerosnalTimeOff] = useState<PersonalTimeOff[]>(
        []
    )
    const [assignedtimeOff, setAssignedTimeOff] = useState<PersonalTimeOff[]>(
        []
    )
    const [currentPage, setCurrentPage] = useState<number>(1)
    const [totalCount, setTotalCount] = useState<number>(0)
    const totalPages = Math.ceil(totalCount / 3)
    const [currentassignedPage, setCurrentAssignedPage] = useState<number>(1)
    const [assignedtotalCount, setAssignedTotalCount] = useState<number>(0)
    const assignedtotalPages = Math.ceil(assignedtotalCount / 3)

    useEffect(() => {
        const getUserstats = async () => {
            try {
                const response = await dashboardstats()
                setuserStats({
                    timeOffCount: response.data.timeOffCount,
                    userCount: response.data.userCount,
                })
                dispatch(HIDE_LOADER())
            } catch (err) {
                // Handle any errors here
                console.error('Error fetching:', err)
                dispatch(HIDE_LOADER())
            }
        }

        getUserstats()
    }, [])

    useEffect(() => {
        dispatch(SHOW_LOADER())
        const gettimeOff = async () => {
            try {
                const response = await personalTimeOff(3, currentPage, id)
                setPerosnalTimeOff(response?.data?.data)
                setTotalCount(response?.data?.totalCount)
                dispatch(HIDE_LOADER())
            } catch (err) {
                // Handle any errors here
                console.error('Error fetching:', err)
                dispatch(HIDE_LOADER())
            }
        }

        gettimeOff()
    }, [currentPage])

    useEffect(() => {
        const getassignedtimeOff = async () => {
            try {
                const response = await assignedTimeOff(3, currentassignedPage)
                setAssignedTimeOff(response?.data?.data)
                setAssignedTotalCount(response?.data?.totalCount)
                dispatch(HIDE_LOADER())
            } catch (err) {
                // Handle any errors here
                console.error('Error fetching:', err)
                dispatch(HIDE_LOADER())
            }
        }

        getassignedtimeOff()
    }, [currentassignedPage])

    const getCurrentPage = (page: number, peronsnal: boolean) => {
        peronsnal ? setCurrentPage(page) : setCurrentAssignedPage(page)
    }

    const column = [
        {
            key: 'leaveType',
            name: `Type`,
            resizable: true,
            sortable: true,
        },
        {
            key: 'status',
            name: `Status`,
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return (
                    <div
                        className={
                            props.row.status === 'Pending'
                                ? 'status'
                                : props.row.status === 'Rejected'
                                  ? 'rej'
                                  : 'appr'
                        }
                    >
                        {props.row.status}
                    </div>
                )
            },
        },
        {
            key: 'date',
            name: `Dates`,
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return (
                    <div className="">
                        {formatDate(props.row.startDate)} -{' '}
                        {formatDate(props.row.endDate)}
                    </div>
                )
            },
        },
    ]

    const column1 = [
        {
            key: 'name',
            name: `Name`,
            resizable: true,
            sortable: true,
        },
        {
            key: 'leaveType',
            name: `Type`,
            resizable: true,
            sortable: true,
        },
        {
            key: 'status',
            name: `Status`,
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return (
                    <div
                        className={
                            props.row.status === 'Pending'
                                ? 'status'
                                : props.row.status === 'Rejected'
                                  ? 'rej'
                                  : 'appr'
                        }
                    >
                        {props.row.status}
                    </div>
                )
            },
        },
        {
            key: 'date',
            name: `Dates`,
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return (
                    <div className="">
                        {formatDate(props.row.startDate)} -{' '}
                        {formatDate(props.row.endDate)}
                    </div>
                )
            },
        },
    ]

    return (
        <div>
            <Layout>
                <div className="row">
                    <div className="col-md-6 col-lg-4">
                        <Card>
                            <div className="dashboard-card">
                                <div className="row d-flex align-items-center">
                                    <h6 className="col-8">Total Employees</h6>
                                    <div className="col-4">
                                        <div className="ms-auto background">
                                            <img src={EmployeeImage} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-5 stats d-flex align-items-center">
                                    <span className="col-6">
                                        <h6>{stats?.userCount}</h6>
                                    </span>
                                    <span className="col-6 text-end">
                                        <p
                                            className="viewstats"
                                            onClick={() => navigate('/users')}
                                        >
                                            View <img src={ArrowUp} />
                                        </p>{' '}
                                    </span>
                                </div>
                            </div>
                        </Card>
                    </div>

                    <div className="col-md-6 col-lg-4">
                        <Card>
                            <div>
                                <div className="row d-flex align-items-center">
                                    <h6 className="col-8">
                                        Total Time-Off Requests
                                    </h6>
                                    <div className="col-4">
                                        <div className="ms-auto background">
                                            <img src={Reqimage} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-5 stats d-flex align-items-center">
                                    <span className="col-6">
                                        <h6>{stats?.timeOffCount}</h6>
                                    </span>
                                    <span className="col-6 text-end">
                                        <p
                                            className="viewstats"
                                            onClick={() =>
                                                navigate('/timeoffreq')
                                            }
                                        >
                                            View <img src={ArrowUp} />
                                        </p>{' '}
                                    </span>
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <Card>
                            <h6>
                                <p>Personal Upcoming Time Off</p>
                            </h6>
                            {!show &&
                            perosnaltimeOff &&
                            perosnaltimeOff?.length > 0 ? (
                                <DataGrid
                                    className="data-grid-table custom"
                                    columns={column}
                                    rows={perosnaltimeOff}
                                    rowHeight={60}
                                    headerRowHeight={40}
                                />
                            ) : (
                                <>
                                    <div className="no-records">
                                        You don’t have any upcoming Paid Time
                                        Off.
                                    </div>
                                </>
                            )}
                            {perosnaltimeOff?.length > 0 && (
                                <CustomPagination
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    getPageNumber={(page: number) =>
                                        getCurrentPage(page, true)
                                    }
                                />
                            )}
                        </Card>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <Card>
                            <div>
                                <h6>Time-Off Requests</h6>
                            </div>
                            {!show &&
                            assignedtimeOff &&
                            assignedtimeOff?.length > 0 ? (
                                <DataGrid
                                    className="data-grid-table custom"
                                    columns={column1}
                                    rows={assignedtimeOff}
                                    rowHeight={60}
                                    headerRowHeight={40}
                                />
                            ) : (
                                <>
                                    <div className="no-records">
                                        There are no upcoming Time-Off Requests.
                                    </div>
                                </>
                            )}
                            {assignedtimeOff?.length > 0 && (
                                <CustomPagination
                                    totalPages={assignedtotalPages}
                                    currentPage={currentassignedPage}
                                    getPageNumber={(page: number) =>
                                        getCurrentPage(page, false)
                                    }
                                />
                            )}
                        </Card>
                    </div>
                </div>
            </Layout>
        </div>
    )
}

export default Dashboard
